import React from "react";
import {Modal, ModalHeader} from "reactstrap";
import Loader from "../../../components/Loader";
import CustomFieldChoicesForm from "./customFieldChoicesForm";

const CustomFieldChoicesModal = (props) => {
  const {data, open, onCancel} = props;

  return (
    <Modal backdrop={"static"} isOpen={open} size="lg" unmountOnClose={true}>
      <Loader />
      <ModalHeader>
        {data && data.id ? "Edit Custom Field Choice" : "Add Custom Field Choice"}
      </ModalHeader>
      <CustomFieldChoicesForm data={data} onCancel={onCancel} />
    </Modal>
  );
};

export default CustomFieldChoicesModal;
